import React, { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { IPresentationQuest } from "../../src/interfaces";
import QuestCard from "../QuestCard";
import { useLoginContext } from "../../hooks";

interface QuestsProps {
  title: string;
  quests: IPresentationQuest[];
  serverDate: Date;
}

function Quests({ title, quests, serverDate }: QuestsProps) {
  const { t } = useTranslation("classroom");
  const { isReadyToQuest, userCompletedQuestsAsynchronous } = useLoginContext();
  const [displayedQuests, setDisplayedQuests] =
    useState<IPresentationQuest[]>(quests);

  useEffect(() => {
    if (isReadyToQuest) {
      const questsWithCompletion = quests.map((quest) => ({
        ...quest,
        completed: userCompletedQuestsAsynchronous.includes(
          Number(quest.collectionId)
        ),
      }));
      setDisplayedQuests(
        questsWithCompletion.sort(
          (a, b) => Number(a.completed) - Number(b.completed)
        )
      );
    } else {
      setDisplayedQuests(
        quests.map((quest) => ({ ...quest, completed: null }))
      );
    }
  }, [isReadyToQuest, userCompletedQuestsAsynchronous]);

  return (
    <div className="flex flex-row justify-center w-full overflow-hidden bg-black">
      <div className="relative xl:px-[95px] pt-2 md:pb-[114px] flex lg:flex-row flex-col justify-between items-center z-0 mt-28 max-w-[1440px] w-full text-white">
        <div className="flex flex-col w-full md:px-4">
          <div className="display-5 md:text-display-3 px-4 mx-auto mb-24 uppercase">
            {title || t("classroomQuests")}
          </div>
          <div className="flex px-4 lg:px-0">
            <div className="flex flex-wrap gap-x-[32px] gap-y-7 md:gap-y-14">
              {displayedQuests.map((quest) => (
                <QuestCard
                  key={quest.id}
                  quest={quest}
                  now={serverDate}
                  dark
                  className="mx-auto md:mx-0"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quests;
